import { Rating } from "@mui/material";
import React from "react";
import { Card } from "react-bootstrap";
import styled from "styled-components";

const DepoyStyle = styled.section`
  display: flex;
  border: 1px solid #121214;
  padding: 15px;
  margin-bottom: 10px;
  background-color: #e1e1e8;
  border-radius: 5px;

  .container {
    display: inline-block;
    color: #121214;
    & h4 {
      font-weight: bold;
      margin-right: 10px;
    }
  }
`;

export default function CardDepoyments({
  id,
  name,
  rating,
  avaliation,
  createdAt,
}) {
  return (
    <DepoyStyle>
      <img
        src="https://img.icons8.com/carbon-copy/256/clothes.png"
        style={{
          width: "75px",
          height: "75px",
          float: "left",
          display: "inline-block",
        }}
      />
      <div className="container" key={id}>
        <h4>{name}</h4>
        <Rating value={rating}/>
        <span>{createdAt}</span>
        <p>{avaliation}</p>
      </div>
    </DepoyStyle>
  );
}
